<section class="revise-section  AUTO_BACK" (clickOutside)="optionsVisibility = false"
         *ngIf="visible && checkpoints && checkpoints.length > 0">
  <span class="icon__revise-1 icon AUTO_BACK_BUTTON" [ngClass]="{'disabled' : disabled}" (click)="back()"
        genTooltip [tooltipHtml]="tooltipHtml | stringTranslate" [tooltipPosition]="tooltipPosition"
        [appendToBody]="true" [tooltipShow]="true">
    <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
    </span>
</section>

